<template>
  <div class="container">
    <Article :article="article" :showAuthor="showAuthor" :term="term"></Article>
  </div>
</template>

<script>
import Article from "./Article";
import { PUBLISHED_STATUS } from "./helpers";

export default {
  name: "ArticlePage",
  components: { Article },
  computed: {
    role() {
      return this.$store.getters.role;
    },
    showAuthor() {
      return (
        this.article.status === PUBLISHED_STATUS ||
        this.$store.getters.role !== "reviewer"
      );
    },
  },
  data() {
    return {
      article: {},
      term: "",
    };
  },
  mounted() {
    let app = this;
    app.axios
      .get(process.env.API_BASE_URL + "/articles/" + app.$route.params.id)
      .then((response) => {
        app.article = response.data;
        app.axios
          .get(process.env.API_BASE_URL + "/terms/" + app.article.term_id)
          .then((response2) => {
            app.term = response2.data.term_english;
          });
      });
  },
};
</script>



// WEBPACK FOOTER //
// ArticlePage.vue?5fbd87b0